export default __webpack_public_path__ + "static/media/sunny.33817f76.png";